import {Component, DestroyRef, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {JsonPipe, NgTemplateOutlet} from '@angular/common';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {MatSelect} from '@angular/material/select';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {IsEnabledDirective} from '../../../../core/directives/is-enabled.directive';
import {
  AccessDeniedMessageComponent
} from '../../../../shared/components/access-denied-message/access-denied-message.component';
import {IndexItemsListComponent} from '../../index-entity/index-items-list/index-items-list.component';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {UnitSelectorComponent} from '../../index-entity/unit-selector/unit-selector.component';
import {
  CriterionService,
  IndexEntityService,
  IndicatorService,
  LandmarkService,
  ReferenceService
} from '../../../apiModule1';
import {MultiSelect3Component} from '../../../../shared/components/multi-select3/multi-select3.component';
import {FillingMethodComponent} from '../../index-entity/filling-method/filling-method.component';
import {ChoiseComponent} from '../../../../shared/components/choise/choise.component';
import {MultiSelect2Component} from '../../../../shared/components/multi-select2/multi-select2.component';
import {map} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {OnInputChange} from '../../OnInputChange';

export const implementers: Implementer[] = [
  {id: 1, name: 'Organization', label: 'Учреждение'},
  {id: 2, name: 'Department', label: 'Структурное подразделение'},
]

export type Implementer = { id: number, name: ImplementerType, label: string }

@Component({
  standalone: true,
  selector: 'pas-dialog-landmarks',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
  imports: [
    MatFormField,
    MatDialogClose,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    JsonPipe,
    MatAutocomplete,
    MatOption,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatSelect,
    AccessDeniedMessageComponent,
    IsEnabledDirective,
    MatIcon,
    MatIconButton,
    IndexItemsListComponent,
    MatButton,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgTemplateOutlet,
    UnitSelectorComponent,
    MultiSelect3Component,
    FillingMethodComponent,
    ChoiseComponent,
    MultiSelect2Component,
  ],
})
export class DialogComponent implements OnInit {

  isNew: boolean = false;

  fillTypes = implementers;

  form = new FormGroup({
    name: new FormControl<string>('',[Validators.required]),
    shortName: new FormControl<string>('',[Validators.required]),
    criterion: new FormControl<Criterion|null>(null,[Validators.required]),
    weight: new FormControl<number|null>(null,[Validators.required ]),
    period: new FormControl<CriterionPeriod|null>(null,[Validators.required]),
    indicator: new FormControl<Indicator[]|null>(null,[Validators.required]),
  })
  isEnabled: boolean = false;
  periods: CriterionPeriod[] = []


  indicator: Indicator = {} as Indicator;
  public indexes: IndexEntry[] = [];

  dataCriterion: OnInputChange<Criterion> = new OnInputChange(this.criterionService, 'apiCriterionGet')
  criterions: Criterion[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
    private referenceService: ReferenceService,
    public dataService: LandmarkService,
    private indexService: IndexEntityService,
    private criterionService: CriterionService,
    public indicatorService: IndicatorService,
    private destroyRef: DestroyRef
  ) {
    this.isNew = data['isNew'];
    console.log('isNew', this.isNew, this.data);

    this.dataCriterion.on()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: Criterion[]) => {
      this.criterions = data
    })

    this.referenceService.apiReferencePeriodsGet()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({values}: { values: CriterionPeriod[] }) => {
      this.periods = values;
    })

    this.referenceService.apiReferencePeriodsGet()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({values}: { values: CriterionPeriod[] }) => {
      this.periods = values;
    })

    if (!this.isNew) {
      this.dataService.apiLandmarkIdGet({id: this.data['id']})
        .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((landmark: Landmark) => {
        console.log('landmark', landmark);
        if (!landmark) return;
        landmark.name && this.form.get('name')!.setValue(landmark.name);
        landmark.shortName && this.form.get('shortName')!.setValue(landmark.shortName);
        landmark.period && this.form.get('period')!.setValue(landmark.period);
        landmark.criterion && this.form.get('criterion')!.setValue(landmark.criterion);
        landmark.weight && this.form.get('weight')!.setValue(landmark.weight);
        landmark.indicators && this.form.get('indicator')!.setValue(landmark.indicators);
      })
    }

    this.criterionService.apiCriterionGet({})
      .pipe(map(v => v.values))
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((v: Criterion[]) => {
      this.criterions = v;
    })

  }

  _findFillTypeByName(name: string) {
    return this.fillTypes.find(x => x.name === name);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onApply() {
    if(this.form.invalid) return;
    const returnData: Landmark = {
      id: this.data['id'] || 0,
      name: this.form.get('name')!.value || '',
      shortName: this.form.get('shortName')!.value || '',
      weight: this.form.get('weight')!.value || 0,
      period: this.form.get('period')!.value || {id: 0, name: 'Годовая'} as CriterionPeriod,
      criterion: this.form.get('criterion')!.value,
      indicators: this.form.get('indicator')!.value || [],
    } as Landmark;
    this.dialogRef.close(returnData);
  }

  ngOnInit() {
    this.indexService.apiIndexGet({})
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({values}: { values: any }) => {
      console.log('indexService', values)
      this.indexes = values;
    })
  }
}

